"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-miniato": {
    "8617a7bb": [{
      "hkey": "1967c9d7",
      "slug": "bucciano",
      "name": "Bucciano",
      "primary": true,
      "skipSearch": false
    }],
    "bucciano-balconevisi": [{
      "hkey": "1967c9d7",
      "slug": "bucciano",
      "name": "Bucciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e4fbf4fc": [{
      "hkey": "dd1301b4",
      "slug": "catena-cigoli-molino-d-egola",
      "name": "Catena-Cigoli-Molino d'Egola",
      "primary": true,
      "skipSearch": false
    }],
    "catena": [{
      "hkey": "dd1301b4",
      "slug": "catena-cigoli-molino-d-egola",
      "name": "Catena-Cigoli-Molino d'Egola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6da332fe": [{
      "hkey": "dd1301b4",
      "slug": "catena-cigoli-molino-d-egola",
      "name": "Catena-Cigoli-Molino d'Egola",
      "primary": true,
      "skipSearch": false
    }],
    "cigoli": [{
      "hkey": "dd1301b4",
      "slug": "catena-cigoli-molino-d-egola",
      "name": "Catena-Cigoli-Molino d'Egola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-miniato"
    }],
    "19b32f87": [{
      "hkey": "3ee580fe",
      "slug": "san-miniato",
      "name": "San Miniato",
      "primary": true,
      "skipSearch": false
    }],
    "montebicchieri": [{
      "hkey": "3ee580fe",
      "slug": "san-miniato",
      "name": "San Miniato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4312df2c": [{
      "hkey": "7042feda",
      "slug": "ponte-a-elsa",
      "name": "Ponte a Elsa",
      "primary": true,
      "skipSearch": false
    }],
    "san-genesio": [{
      "hkey": "7042feda",
      "slug": "ponte-a-elsa",
      "name": "Ponte a Elsa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-miniato"
    }],
    "3cd717d6": [{
      "hkey": "d79729f0",
      "slug": "la-scala",
      "name": "La Scala",
      "primary": true,
      "skipSearch": false
    }],
    "scala": [{
      "hkey": "d79729f0",
      "slug": "la-scala",
      "name": "La Scala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;